import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'preco'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos/${id}/precos`
    case Actions.CREATE_PRECO_ESTRANGEIRO:
      return `/acl/contratos/${id}/precos/create_preco_estrangeiro`
    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/precos/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingPrecoSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingPrecoSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_PRECO_SUCCESS = 'LOADING_PRECO_SUCCESS'
export function loadingPrecoSuccess(preco) {
  return {
    type: LOADING_PRECO_SUCCESS,
    preco,
  }
}

export const DESTROYING_PRECO_SUCCESS = 'DESTROYING_PRECO_SUCCESS'
export function destroyingPrecoSuccess(precoId) {
  return {
    type: DESTROYING_PRECO_SUCCESS,
    precoId,
  }
}

export function fetchMultiplePreco(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchPreco(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createPreco(parentId, preco) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.CREATE, parentId), 'POST', preco).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createPrecoEstrangeiro(parentId, preco) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.CREATE_PRECO_ESTRANGEIRO, parentId), 'POST', preco).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updatePreco(id, preco) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', preco).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyPreco(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const preco = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_PRECO_SUCCESS: {
      const { preco: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_PRECO_SUCCESS:
      return state.delete(action.precoId.toString())

    default:
      return state
  }
}

export default preco
